import React from "react"
import { routePaths } from "../../../Routes"
import symbolLg from "../Assets/superai_symbol_lg.png"
import symbolMd from "../Assets/superai_symbol_md.png"
import symbolSm from "../Assets/superai_symbol_sm.png"
import symbolWhiteLg from "../Assets/superai_symbol_white_lg.png"
import symbolWhiteMd from "../Assets/superai_symbol_white_md.png"
import symbolWhiteSm from "../Assets/superai_symbol_white_sm.png"
import textLg from "../Assets/superai_text_lg.png"
import textMd from "../Assets/superai_text_md.png"
import textSm from "../Assets/superai_text_sm.png"
import textWhiteLg from "../Assets/superai_text_white_lg.png"
import textWhiteMd from "../Assets/superai_text_white_md.png"
import textWhiteSm from "../Assets/superai_text_white_sm.png"
import styles from "./CompanyLogo.module.css"

interface CompanyLogoProps {
    size?: "sm" | "md" | "lg"
    className?: string
    type?: "color" | "white"
    variant?: "symbol" | "text" | "full"
    glow?: "light" | "med" | "dark" | "none"
    noInteraction?: boolean
}

const images = {
    symbol: {
        white: {
            sm: symbolWhiteSm,
            md: symbolWhiteMd,
            lg: symbolWhiteLg
        },
        color: {
            sm: symbolSm,
            md: symbolMd,
            lg: symbolLg
        }
    },
    text: {
        white: {
            sm: textWhiteSm,
            md: textWhiteMd,
            lg: textWhiteLg
        },
        color: {
            sm: textSm,
            md: textMd,
            lg: textLg
        }
    }
}

const symbolSizes = {
    sm: {
        white: { width: 100, height: 116 },
        color: { width: 100, height: 115 }
    },
    md: {
        white: { width: 250, height: 291 },
        color: { width: 250, height: 288 }
    },
    lg: {
        white: { width: 370, height: 430 },
        color: { width: 390, height: 450 }
    }
}

export const CompanyLogo = ({
    size = "lg",
    className,
    type = "color",
    variant = "full",
    glow = "none",
    noInteraction
}: CompanyLogoProps) => {
    const classes = [
        styles.CompanyLogo,
        styles[`CompanyLogo_size_${size}`],
        styles[`CompanyLogo_type_${type}`],
        styles[`CompanyLogo_variant_${variant}`],
        styles[`CompanyLogo_glow_${glow}`],
        ...(className ? [className] : [])
    ].join(" ")

    const img = () => {
        switch (variant) {
            // return the symbol or text image
            // that fits the color/glow/size settings
            // that fits the color/size settings
            case "symbol":
            case "text":
                return (
                    <div className={classes}>
                        <img
                            {...symbolSizes[size][type]}
                            src={images[variant][type][size]}
                            alt="super.AI Logo"
                            loading="lazy"
                        />
                    </div>
                )
            // return the combined symbol/text
            case "full":
            default:
                return (
                    <div className={classes}>
                        <div>
                            <img
                                {...symbolSizes[size][type]}
                                src={images.symbol[type][size]}
                                alt="super.AI Logo"
                                loading="lazy"
                            />
                        </div>
                        <div>
                            <img
                                src={images.text[type][size]}
                                alt="super.AI Logo"
                                loading="lazy"
                            />
                        </div>
                    </div>
                )
        }
    }

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
            href={noInteraction ? undefined : routePaths.home()}
            className={`${styles.Link} ${
                noInteraction ? "pointer-events-none" : ""
            }`}
        >
            {img()}
        </a>
    )
}
